<template>
  <v-row dense class="operation-summary-strip">
    <v-col
      v-for="item in normalizedItems"
      :key="item.label"
      cols="12"
      sm="6"
      md="3"
    >
      <v-card outlined class="operation-summary-strip__item">
        <div class="operation-summary-strip__label">{{ item.label }}</div>
        <div class="operation-summary-strip__value">
          {{ item.value || "-" }}
        </div>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "OperationSummaryStrip",
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    normalizedItems() {
      return this.items || [];
    },
  },
};
</script>

<style scoped>
.operation-summary-strip {
  margin-bottom: 12px;
}

.operation-summary-strip__item {
  background: #fafafa;
  height: 100%;
  padding: 13px 14px;
}

.operation-summary-strip__label {
  color: #8d8d8d;
  font-size: 11px;
  font-weight: 700;
  margin-bottom: 6px;
}

.operation-summary-strip__value {
  color: #2b2b2b;
  font-size: 15px;
  font-weight: 700;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
